import api, { transformRequest, transformResponse } from "services/api";

export const personalAccessTokensAPI = api
  .enhanceEndpoints({ addTagTypes: ["DeveloperPortalPersonalAccessTokens"] })
  .injectEndpoints({
    endpoints: (build) => ({
      getDeveloperPortalPersonalAccessTokens: build.query({
        query: () => `/api/v1/auth/personal-access-tokens/`,
        transformResponse: (response) => transformResponse(response),
        providesTags: (results) =>
          results
            ? // successful query
              [
                ...results.map(({ uuid }) => ({
                  type: "DeveloperPortalPersonalAccessTokens",
                  uuid,
                })),
                { type: "DeveloperPortalPersonalAccessTokens", id: "LIST" },
              ]
            : // an error occurred, but we still want to refetch this query when `{ type: 'DeveloperPortalPersonalAccessTokens', id: 'LIST' }` is invalidated
              [{ type: "DeveloperPortalPersonalAccessTokens", id: "LIST" }],
      }),
      deleteDeveloperPortalPersonalAccessToken: build.mutation({
        query: (payload) => ({
          url: `/api/v1/auth/personal-access-tokens/${payload.id}/delete/`,
          method: "POST",
          body: transformRequest(payload),
        }),
        invalidatesTags: [{ type: "DeveloperPortalPersonalAccessTokens", id: "LIST" }],
      }),
      postDeveloperPortalPersonalAccessTokens: build.mutation({
        query: ({ ...values }) => ({
          url: `/api/v1/auth/personal-access-tokens/create/`,
          method: "POST",
          body: transformRequest(values),
          headers: { "aktos-suppress-error": "true" },
        }),
        transformResponse: (response) => transformResponse(response),
        // Invalidates all PersonalAccessTokens-type queries providing the `LIST` id - after all, depending of the sort order,
        invalidatesTags: [{ type: "DeveloperPortalPersonalAccessTokens", id: "LIST" }],
      }),
    }),
  });

export const {
  useDeleteDeveloperPortalPersonalAccessTokenMutation,
  useGetDeveloperPortalPersonalAccessTokensQuery,
  useLazyGetDeveloperPortalPersonalAccessTokensQuery,
  usePostDeveloperPortalPersonalAccessTokensMutation,
} = personalAccessTokensAPI;
